import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ShiftTime = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const adminmob = queryParams.get("adminmob");
  const branchId = queryParams.get("branchId");
  const empmobile = queryParams.get("empmobile");
  const navigate = useNavigate();
  const udiseNumber= localStorage.getItem("udiseNumber")
  const [shiftData, setShiftData] = useState(
    ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => ({
      day,
      weekOff: false,
      startShift: "",
      endShift: "",
    }))
  );
  const [halfDayTime, setHalfDayTime] = useState("00:00:00"); 
  const [mandatoryHalfDayHours, setMandatoryHalfDayHours] = useState("0");
const [mandatoryHalfDayMinutes, setMandatoryHalfDayMinutes] = useState("0");
const [fullDayHours, setFullDayHours] = useState("0");
const [fullDayMinutes, setFullDayMinutes] = useState("0");
const [punchInTime, setPunchInTime] = useState("0:00");
const [punchOutTime, setPunchOutTime] = useState("0:00");
const [latemarkTime, setLateMarkTime] = useState("0:00");
const [latemarkTime1, setLateMarkTime1] = useState("0:00");
const [mandatoryHalfDaySeconds, setMandatoryHalfDaySeconds] = useState("0");
const [fullDaySeconds, setFullDaySeconds] = useState("0");

const [attendanceFrom, setAttendanceFrom] = useState("office"); 

  // State for automation rules
// const [automationRules, setAutomationRules] = useState({
//   halfDayTime: "",
//   mandatoryHalfDayHours: "",
//   mandatoryHalfDayMinutes: "",
//   fullDayHours: "",
//   fullDayMinutes: "",
//   punchInTime: "",
//   punchOutTime: "",
//   latemarkTime: "",
//   latemarkTime1: "",
// });
  // State for popup visibility
  const [isPopupVisible, setIsPopupVisible] = useState(false);
   const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);
      
 
  // Generate time options in HH:mm:ss format
  const generateTimeOptions = () => {
    const options = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m++) {
        for (let s = 0; s < 60; s += 30) { // Change to 60 for every second
          const time = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
          options.push(time);
        }
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();
  
  const handleMandatoryHalfDaySecondsChange = (e) => {
    setMandatoryHalfDaySeconds(e.target.value);
  };

  const handleFullDaySecondsChange = (e) => {
    setFullDaySeconds(e.target.value);
  };

   // Fetch PunchTimings data from Firebase
   useEffect(() => {
    if (adminmob && branchId && empmobile) {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/PunchTimings.json`;
  
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data) {
            console.log("Fetched data:", data);
            setHalfDayTime(data.halfDayTime || "00:00:00");
            setMandatoryHalfDayHours(data.halfhours.split(":")[0] || "0");
            setMandatoryHalfDayMinutes(data.halfhours.split(":")[1] || "0");
            setMandatoryHalfDaySeconds(data.halfhours.split(":")[2] || "0");
            setFullDayHours(data.workingHours.split(":")[0] || "0");
            setFullDayMinutes(data.workingHours.split(":")[1] || "0");
            setFullDaySeconds(data.workingHours.split(":")[2] || "0");
            setPunchInTime(data.punchInTime || "00:00:00");
            setPunchOutTime(data.punchOutTime || "00:00:00");
            setLateMarkTime(parseInt(data.latemarkTime) || 0); // Update latemarkTime state
  
            // Update shiftData based on fetched data
            const updatedShiftData = shiftData.map((item) => {
              if (data[item.day]) {
                const weekOff = data[item.day].includes("Week Off");
                const timings = weekOff ? "" : data[item.day].split("&&");
                return {
                  ...item,
                  weekOff,
                  startShift: timings[0] ? timings[0] : "", // Set startShift
                  endShift: timings[1] ? timings[1] : "",   // Set endShift
                };
              }
              return item;
            });
            setShiftData(updatedShiftData);
          } else {
            console.error("No data found");
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, [adminmob, branchId, empmobile]);

  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${suffix}`;
  };

  const convertTo24Hour = (time) => {
    const [hourMinute, period] = time.split(" ");
    let [hours, minutes] = hourMinute.split(":").map(Number);
    if (period === "PM" && hours < 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  };

  const handleInputChange = (index, field, value) => {
    const updatedShiftData = [...shiftData];
    updatedShiftData[index][field] = value;
    setShiftData(updatedShiftData);
  };


  const handleHalfDayTimeChange = (event) => {
    // setAutomationRules({ ...automationRules, halfDayTime: event.target.value })
    setHalfDayTime(event.target.value);
  };

  const handleMandatoryHalfDayHoursChange = (event) => {
    // setAutomationRules({ ...automationRules, mandatoryHalfDayHours: event.target.value })
    setMandatoryHalfDayHours(event.target.value);
  };
  
  const handleMandatoryHalfDayMinutesChange = (event) => {
    // setAutomationRules({ ...automationRules, mandatoryHalfDayMinutes: event.target.value })
    setMandatoryHalfDayMinutes(event.target.value);
  };

  const handleFullDayHoursChange = (event) => {
    // setAutomationRules({ ...automationRules, fullDayHours: event.target.value })
    setFullDayHours(event.target.value);
  };
  
  const handleFullDayMinutesChange = (event) => {
    // setAutomationRules({ ...automationRules, fullDayMinutes: event.target.value })
    setFullDayMinutes(event.target.value);
  };

  const handlePunchInChange = (event) => {
    // setAutomationRules({ ...automationRules, punchInTime: event.target.value })
    setPunchInTime(event.target.value);
  }

  const handlePunchOutChange = (event) => {
    // setAutomationRules({ ...automationRules, punchOutTime: event.target.value })
    setPunchOutTime(event.target.value);
  }

  const handleLateMarkTimeChange = (event) => {
    // setAutomationRules({ ...automationRules, latemarkTime: event.target.value })
    setLateMarkTime(event.target.value);
  }

  const handleLateMarkTimeChange1 = (event) => {
    // setAutomationRules({ ...automationRules, latemarkTime1: event.target.value })
    setLateMarkTime1(event.target.value);
  }

  const saveDataToFirebase = () => {
    if (!adminmob || !branchId || !empmobile) {
        alert("Invalid adminmob, branchId, or empmobile!");
        return;
    }

    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/PunchTimings.json`;

    const dayFullNames = {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday",
    };

    // Format the data to match the required structure
    const formattedData = shiftData.reduce((acc, { day, weekOff, startShift, endShift }) => {
        acc[day] = weekOff
            ? `All ${dayFullNames[day]}s Week Off`
            : `${startShift}&&${endShift}`; // Use "&&" to separate start and end times
        return acc;
    }, {});

    // Add additional fields to the formatted data
    formattedData.halfDayTime = halfDayTime; // Assuming halfDayTime is already in HH:mm:ss format
    formattedData.halfhours = `${mandatoryHalfDayHours.padStart(2, '0')}:${mandatoryHalfDayMinutes.padStart(2, '0')}:${mandatoryHalfDaySeconds.padStart(2, '0')}`; // HH:mm:ss
    formattedData.punchInTime = punchInTime; // Assuming punchInTime is already in HH:mm:ss format
    formattedData.punchOutTime = punchOutTime; // Assuming punchOutTime is already in HH:mm:ss format
    formattedData.workingHours = fullDayHours; // Save only hours
    formattedData.latemarkTime = latemarkTime.split(":")[1];  // Assuming latemarkTime and latemarkTime1 are in HH:mm:ss format

    // Add AttendFrom field
    formattedData.AttendFrom = attendanceFrom; // Save the selected attendance source

    // Save the fo?rmatted data to Firebase
    fetch(url, {
        method: "PUT", // Use PUT to overwrite the existing data
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formattedData),
    })
    .then((response) => {
        if (response.ok) {
            alert("Data saved successfully!");
        } else {
            throw new Error("Failed to save data");
        }
    })
    .catch((error) => {
        console.error("Error saving data to Firebase:", error);
        alert("Failed to save data.");
    });
};
  
  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
};

  const styles = {
    mainContent: {
      padding: "20px",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#f9f9f9",
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Optional shadow for better appearance
      backgroundColor:'#ecf2fc',
      width:'1200px',
      marginLeft:'150px',
      border:'1px solid black'
    },

    heading: {
      textAlign: "center",
      fontSize: "1.8rem",
      fontWeight: "bold",
      color: "white",
      marginBottom: "20px",
      border:'1px solid black',
      borderRadius:'8px',
      width:'250px',
      marginLeft:'410px',
      backgroundColor:'#1B4332', padding:'5px 30px'
    },
    label: {
      display: "block",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#555",
      marginBottom: "10px",
      marginRight:'700px'
    
    },
    table: {
      width: "90%",
      margin: "0 auto",
      textAlign: "center",
      borderCollapse: "collapse",
      backgroundColor: "#fff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      overflow: "hidden",
    },
    th: {
      fontWeight: "bold",
      backgroundColor: "#f4f4f4",
      color: "#333",
      border: "1px solid #ddd",
      padding: "10px",
    },
    td: {
      border: "1px solid #ddd",
      padding: "10px",
    },
    checkbox: {
      cursor: "pointer",
      width: "18px",
      height: "18px",
    },
    inputTime: {
      padding: "5px",
      fontSize: "0.9rem",
      width: "90%",
      boxSizing: "border-box",
      border: "1px solid #ccc",
      borderRadius: "4px",
    },
    inputTimeDisabled: {
      backgroundColor: "#e9e9e9",
      color: "#999",
    },
    button: {
      display: "block",
      width: "150px",
      margin: "20px auto",
      padding: "10px 15px",
      backgroundColor: "#1B4332",
      color: "white",
      fontSize: "1rem",
      fontWeight: "bold",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    buttonHover: {
      backgroundColor: "#0056b3",
    },
    popup: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      backgroundColor: "white",
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', 
      zIndex: 1000,
      backgroundColor:'#ecf2fc',
    },
    overlay: {
      position: "fixed",
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 999,
      backgroundColor:'white',
    },
  };

  return (
      <div className="main-content-of-page" >
      <div style={styles.mainContent}>
      <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginTop: '30px', 
                            marginLeft: '1100px' // Add some space between buttons
                        }} onClick={handleClose}> 
                            X 
                        </button>
        <h2 style={styles.heading}>{language === "English" ? "Set Shift" : "शिफ्ट सेट करा"}</h2>
        <div style={{ textAlign: 'center' }}>
          <label style={styles.label}>{language === "English" ? "Work Timings " : "कामाची वेळ"}</label>
        </div>
        <div style={{ marginTop: "20px" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th  className="text-center" style={styles.th}>{language === "English" ? "Day " : "दिवस"}</th>
                <th className="text-center" style={styles.th}>{language === "English" ? "Weekoff " : "आठवडा सुट्टी"}</th>
                <th className="text-center" style={styles.th}>{language === "English" ? "Start Shift " : "शिफ्ट सुरू करा"}</th>
                <th className="text-center" style={styles.th}>{language === "English" ? "End Shift " : "शिफ्ट समाप्त करा"}</th>
              </tr>
            </thead>
            <tbody>
  {shiftData.map((item, index) => (
    <tr key={index}>
      <td style={styles.td}>{item.day}</td>
      <td style={styles.td}>
        <input
          type="checkbox"
          style={styles.checkbox}
          checked={item.weekOff}
          onChange={(e) =>
            handleInputChange(index, "weekOff", e.target.checked)
          }
        />
      </td>
      <td style={styles.td}>
        <select
          value={item.startShift || "00:00:00"} // Default to "00:00:00" if empty
          onChange={(e) => handleInputChange(index, "startShift", e.target.value)}
          disabled={item.weekOff}
        >
          {timeOptions.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
      </td>
      <td style={styles.td}>
        <select
          value={item.endShift || "00:00:00"} // Default to "00:00:00" if empty
          onChange={(e) => handleInputChange(index, "endShift", e.target.value)}
          disabled={item.weekOff}
        >
          {timeOptions.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
      </td>
    </tr>
  ))}
</tbody>
          </table>
          <div style={{ marginTop: "20px" }}>
            <button style={styles.button} onClick={saveDataToFirebase}>
              Save
            </button>
            <button
              style={styles.button}
              onClick={() => setIsPopupVisible(true)}
            >
             {language === "English" ? " Set Automation Rules " : "ऑटोमेशन नियम सेट करा"}
            </button>
          </div>
        </div>

{/* Popup for Set Automation Rules */}

{isPopupVisible && (
  
  <>
  <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(20px) saturate(180%) !important',
      zIndex: 1000,
    }} onClick={() => setIsPopupVisible(false)} />
    
    <div style= {{
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "20px",
  backgroundColor: "white",
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', 
  zIndex: 1000,
  backgroundColor:'#ecf2fc',
  border: '2px solid black', // Add this line to add a border
    }}>
      <h3 style={{textAlign:'center',border:'2px solid black',borderRadius:'8px',width:'360px',marginLeft:'160px',backgroundColor:'#1B4332',color:'white'}}>{language === "English" ? " Set Automation Rules " : "ऑटोमेशन नियम सेट करा"}</h3>
      <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
      <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}>{language === "English" ? " Auto Half Day After  " : "ऑटो हाफ डे नंतर"}</label>
      <select
        value={halfDayTime} // Default value
        onChange={(e) => setHalfDayTime(e.target.value)} // Update state on change
        style={{ padding: '8px', border: '2px solid black', borderRadius: '4px', width: '300px', height: '40px' }}
      >
        {timeOptions.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
    </div>

    <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
  <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}>{language === "English" ? "Mandatory Half Day Hours " : "अनिवार्य अर्धा दिवस तास"}</label>
  <div style={{ display: 'flex', alignItems: 'center' }}>
  <input
    type="text"
    placeholder="HH"
    style={{ width: "150px", padding: "8px", border: '2px solid black', borderRadius: "4px", height: '40px', marginRight: '10px' }}
    value={mandatoryHalfDayHours}
    onChange={handleMandatoryHalfDayHoursChange}
  />
  <input
    type="text"
    placeholder="MM"
    style={{ width: "150px", padding: "8px", border: '2px solid black', borderRadius: "4px", height: '40px', marginRight: '10px' }}
    value={mandatoryHalfDayMinutes}
    onChange={handleMandatoryHalfDayMinutesChange}
  />
  <input
    type="text"
    placeholder="SS"
    style={{ width: "150px", padding: "8px", border: '2px solid black', borderRadius: "4px", height: '40px' }}
    value={mandatoryHalfDaySeconds} // Add state for seconds
    onChange={handleMandatoryHalfDaySecondsChange} // Add handler for seconds
  />
  </div>
</div>


<div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
  <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}>{language === "English" ? "Full Day Hours " : "पूर्ण दिवसाचे तास"}</label>
  <input
    type="text"
    placeholder="HH"
    style={{ width: "300px", padding: "8px", border: '2px solid black', borderRadius: "4px", height: '40px' }}
    value={fullDayHours}
    onChange={handleFullDayHoursChange}
  />
</div>
       <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
       <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}> Punch In Time</label>
       <select value={punchInTime} onChange={(e) => setPunchInTime(e.target.value)} style={{ padding: '8px', border: '2px solid black', borderRadius: '4px', width: '300px', height: '40px' }}>
       {timeOptions.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
       {/* <input type="time"  value={punchInTime} onChange={handlePunchInChange}/> */}
       </div>

       <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
       <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}> Punch Out Time</label>
       <select value={punchOutTime} onChange={(e) => setPunchOutTime(e.target.value)} style={{ padding: '8px', border: '2px solid black', borderRadius: '4px', width: '300px', height: '40px' }}>
       {timeOptions.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
       </div> 

       
       <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center' }}>
      <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}> Late Mark Time</label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
  {/* <label style={{ fontSize: "1rem", color: "#000" }}> Late Mark Time</label> */}
  {/* <input type="number" value={latemarkTime.split(":")[0]} onChange={(e) => setLateMarkTime(`${e.target.value}:${latemarkTime.split(":")[1]}:00`)} style={{ width: "20%", padding: "8px", marginTop: "5px", border: "1px solid #ccc", borderRadius: "4px",marginLeft:'107px'}} /> */}
  <input type="number" value={latemarkTime} onChange={(e) => setLateMarkTime(e.target.value)} style={{ width: "150px", padding: "8px", border: '2px solid black', borderRadius: "4px", height: '40px' }} />
</div>

     
       </div>

       <h3 style={{ margin: '20px 0', borderBottom: '1px solid #ccc' }}></h3>
       <div>
       <label style={{ fontSize: "1rem", color: "#000", fontWeight: "bold", marginRight: "10px" }}>{language === "English" ? " Mark Attendance From " : "पासून उपस्थिती"}</label>
        {/* First Radio Button */}
       <div style={{textAlign:'center'}}>
       <input
  type="radio"
  id="option1"
  name="attendance"
  value="office"
  checked={attendanceFrom === "office"} // Set checked based on state
  onChange={() => setAttendanceFrom("office")} // Update state on change
/>
       <label htmlFor="option1" style={{ marginLeft: '5px',textAlign:'center' }}>{language === "English" ? "From School " : "शाळेतून"}</label>
       </div>
        {/* Second Radio Button */}
        <div style={{textAlign:'center'}}>
        <input
  type="radio"
  id="option2"
  name="attendance"
  value="anywhere"
  checked={attendanceFrom === "anywhere"} // Set checked based on state
  onChange={() => setAttendanceFrom("anywhere")} // Update state on change
/>
        <label htmlFor="option2" style={{ marginLeft: '5px',textAlign:'center' }}>{language === "English" ? "From Anywhere " : "कुठूनही"}</label>
        </div>
      </div>
      <h4 style={{ margin: '20px 0', borderBottom: '1px solid #ccc' }}></h4>
      <div style={{textAlign:'center'}}>
      <button onClick={saveDataToFirebase} style={{backgroundColor:'#1B4332',fontWeight:'bold',color:'white',border:'2px solid',width:'100px',fontSize:'20px',borderRadius:'6px'}} > Save </button>
      </div>
      <button  onClick={() => setIsPopupVisible(false)} style={{ position: 'absolute', top: '0px', right: '10px', cursor: 'pointer', fontSize: '20px',color:"red",fontWeight:'bold',marginTop: "15px" }}>X</button>
    </div>
   
  </>
)}
      </div>
      </div>
  
  );
};

export default ShiftTime;